module.exports = __webpack_public_path__ + "img/25-eng.000cc442.png";